import * as sonbp from "sonbp";
import * as ifbase from "./base";
import * as listener from './listener'
import * as tool from './tool'


/**
 * 結果返却用 
 */
export { IResult } from "./base";

/**
 * SonbpIF 
 */
export class SonbpIfClass {

	private _ifdto: ifbase.ifDto = null;
	private _divId: string;

	/**
	 * コンストラクタ
	 */
	constructor() {
		this._ifdto = new ifbase.ifDto();
	}

	/* ============================================================
	 * 公開I/F
	 * ============================================================ */

	/**
	 * sonbp初期化
	 */
	public sonbpInit(vue: Vue, divId: string, uri_prefix: string, uri_prefix2: string, client: string, token: string, callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] sonbpInit.");
		var own = this;

		this._divId = divId;
		this._ifdto.vue = vue;

		this._ifdto.setCallbackError(function (e) {
			if (!own._ifdto.callbackOnApiError(e)) return;
			callback({ code: 9, msg: "sonbpの初期化に失敗しました。", ex: e });
		});

		try {

			this.resizeContents();

			this._ifdto.client = client;
			this._ifdto.fileKeyCache = [];
			this._ifdto.bpView = new sonbp.view(divId);

			ifbase.sonbpInit(this._ifdto, divId, uri_prefix, uri_prefix2, token);

			// リスナー準備
			listener.init(own._ifdto, own.onChange(), own.setBaseListener(), own.setBaseListener(), own.onExchange());

			// エディター準備
			listener.editor.init(own._ifdto, own.onEditStateFunc());

			// 初期処理完了ハンドリング
			this._ifdto.cleareCollbackError();
			callback({ code: 0 });

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * オプション指定
	 */
	public setOption(opt: any): void {

		if (opt.put_range) {

			if (isNaN(opt.put_range.w) || isNaN(opt.put_range.h)) {
				throw new Error("アイテム働範囲の指定が正しくありません。");
			}
			this._ifdto.txtRange = {
				w: opt.put_range.w,
				h: opt.put_range.h
			};
		}

		if (opt.put_range_stamp) {

			if (isNaN(opt.put_range_stamp.w) || isNaN(opt.put_range_stamp.h)) {
				throw new Error("アイテム働範囲の指定が正しくありません。");
			}
			this._ifdto.txtRangeStamp = {
				w: opt.put_range_stamp.w,
				h: opt.put_range_stamp.h
			};
		}

		if (opt.page_offset) {

			if (isNaN(opt.page_offset.x) || isNaN(opt.page_offset.y)) {
				throw new Error("オフセット位置の指定が正しくありません。");
			}
			this._ifdto.pageOffset = {
				x: opt.page_offset.x,
				y: opt.page_offset.y
			};
		}
	}

	/**
	 * 通信エラー通知
	 */
	public onApiError(callback: (e: any) => boolean): void {
		//console.log("[sonbpIf] onApiError.");

		this._ifdto._onApiError = callback;
	}

	/**
	 * sonbp起動
	 */
	public sonbpStart(callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] sonbpStart.");
		var own = this;

		this._ifdto.setCallbackError(function (e: any) {
			if (!own._ifdto.callbackOnApiError(e)) return;
			callback({ code: 9, msg: "sonbpの起動に失敗しました。", ex: e });
		});

		try {

			ifbase.sonbpStart(this._ifdto, callback);

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * Canvasサイズ調整
	 */
	public resizeContents(pageAreaSize?: number): void {
		//console.log("[sonbpIf] resizeContents.");

		var boxView = $("#" + this._divId);
		var parent = boxView.parent();

		var aHeight = parent.height();
		var aWidth = parent.width();

		boxView.height(aHeight);
		boxView.width(aWidth);

		// [sonbp] リサイズの通知
		// 画面サイズの変更をsonbpに通知します。
		if (this._ifdto != null && this._ifdto.bpView != null) {
			this._ifdto.bpView.resize();

			if (this._ifdto.client == ifbase.constants.CLIENT_SP)
				ifbase.util.autoScaleSP(this._ifdto);
			else
				ifbase.util.autoScale(this._ifdto, pageAreaSize);

			this._ifdto.normalScale.normalScaleRate = this._ifdto.bpView._dm.scaleRate;
			this._ifdto.normalScale.normalDrawPoint = this._ifdto.bpView._dm.drawPoint;
			//console.debug("normalScale", this._ifdto.bpView._dm.scaleRate, this._ifdto.bpView._dm.drawPoint);
		}
	}

	/**
	 * 処理モード切換え
	 */
	public setMode(mode: string, callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] setMode. mode=" + mode);

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "処理モードの切換えに失敗しました。", ex: e });
		});

		try {

			if (this._ifdto.client == ifbase.constants.CLIENT_SP) {

				let selId = this._ifdto.activeSelector.getPoscaItem()?.id;
				if (selId == null && mode == ifbase.constants.MODE_PHOTO_MANI) {
					//SPの画像編集モードへの切換えはアイテム選択済み必須
					throw new Error("アイテムが選択されていません。(SP)");
				}

				tool.poscaMode.changeMode(this._ifdto, mode);

				tool.poscaMode.zoomPhotoBox4SP(this._ifdto, selId);

			} else {

				//通常は素直に処理モード切換え
				tool.poscaMode.changeMode(this._ifdto, mode);
			}

			//Canvasを最新描画
			this._ifdto.bpView._dm.reDraw();

			this._ifdto.cleareCollbackError();
			callback({ code: 0 });

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * PDF保存
	 */
	public save(callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] save.");
		var own = this;

		this._ifdto.setCallbackError(function (e: any) {
			if (!own._ifdto.callbackOnApiError(e)) return;
			callback({ code: 9, msg: "編集データの保存に失敗しました。", ex: e });
		});

		try {

			ifbase.save(this._ifdto, callback);

		} catch (e) {
			this._ifdto.callbackError(e);
		}
	}

	/**
	 * 仕上がり変更
	 */
	public setAreaView(area_type: string): void {
		//console.log("[sonbpIf] setAreaView. area_type=" + area_type);

		let layer = ifbase.util.getLayer(this._ifdto, ifbase.constants.LTYPE_AREA).layer;
		var items = ifbase.util.getItems(layer.items, function (item: sonbp.object.baseItem): boolean {
			return item.info.vendor_property.ffpsc?.item_type == "AREA_IMG";
		});
		for (var i = 0; i < items.length; i++) {

			//表示切換えは透過設定で実現
			items[i].graphic.fill_opacity = items[i].info.vendor_property.ffpsc.area_type == area_type ? 1.0 : 0.0;
		}
		this._ifdto.areaType = area_type;

		//Canvasを最新描画
		this._ifdto.bpView._dm.reDraw();
	}

	/**
	 * レイヤー情報取得	
	 */
	public getLayers(): any[] {
		//console.log("[sonbpIf] getLayers.");

		var layers = this._ifdto.bpView._om._doc.pages[0].layers;
		var rtn = [];
		for (var i = 0; i < layers.length; i++) {

			if (layers[i].info.vendor_property.ffpsc !== undefined)
				rtn.push(layers[i].info.vendor_property.ffpsc);
		}

		//clone
		rtn = JSON.parse(JSON.stringify(rtn));

		return rtn;
	}

	/**
	 * ページサイズ取得
	 */
	public getPageSize(): { w: number, h: number } {
		//console.log("[sonbpIf] getPageSize.");

		let mb = this._ifdto.bpView._om._doc.pages[0].size.mediaBoxRect;

		return {
			w: mb.width,
			h: mb.height
		};
	}

	/**
	 *【デバッグ用】sonbp.viewを返す
	 */
	public getSonbpView(): sonbp.view {
		//console.log("[sonbpIf] getView.");

		return this._ifdto.bpView;
	}

	/**
	 *【デバッグ用】ifbase.ifDtoを返す
	 */
	public getIfDto(): ifbase.ifDto {
		//console.log("[sonbpIf] getDto.");

		return this._ifdto;
	}

	/**
	 * アイテム選択指示
	 */
	public selectItem(item_type: string, idx: string, callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] selectItem.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "アイテム選択に失敗しました。", ex: e });
		});

		try {

			tool.itemMani.selectItem(this._ifdto, item_type, idx);

			this._ifdto.cleareCollbackError();
			callback({ code: 0 });

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * アイテム選択解除
	 */
	public selectItemClear(): void {
		//console.log("[sonbpIf] selectItemClear.");

		this._ifdto.activeSelector.clear();
	}

	/**
	 * アイテム選択通知
	 */
	public onChangeSelectItem(callback: (vp: any) => void): void {
		//console.log("[sonbpIf] onChangeSelectItem.");

		this._ifdto._onChange = callback;
	}

	/**
	 * ２つの画像枠の画像変更通知
	 */
	public onExhangePhtoItem(callback: (a: { waku: any, img: any }, b: { waku: any, img: any }) => void): void {

		this._ifdto._onExchange = callback;
	}

	/**
	 * 選択アイテム取得
	 */
	public getSelectItem(): any {
		//console.log("[sonbpIf] getSelectItems.");

		return this._ifdto.activeSelector.getPoscaItem();
	}

	/**
	 * アイテムリスト取得
	 */
	public getItems(item_type: string[], callback: (res: ifbase.IResult, list: any[]) => void): void {
		//console.log("[sonbpIf] getItems.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "アイテムリスト取得に失敗しました。", ex: e }, []);
		});

		try {

			let list = tool.itemMani.getAllItems(this._ifdto, item_type);

			this._ifdto.cleareCollbackError();
			callback({ code: 0 }, list);

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * アイテム回転
	 */
	public rotateItem(deg: number, callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] rotateItem.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "アイテム回転に失敗しました。", ex: e });
		});

		try {

			let items = this._ifdto.activeSelector.getItems();
			if (items.length == 0) {
				throw new Error("アイテムが選択されていません。");
			}

			if (isNaN(deg)) {
				throw new Error("引数が不正です。scale=" + deg);
			}

			let result = tool.itemMani.rotate(this._ifdto, -deg);
			if (!result) {
				//エラーはNotice通知でくるのでここは抜けるだけ
				return;
			}

			this._ifdto.cleareCollbackError();
			callback({ code: 0 });

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * アイテム拡大縮小
	 */
	public scaleItem(scale: number, callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] scaleItem.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "アイテム拡大縮小に失敗しました。", ex: e });
		});

		try {

			let items = this._ifdto.activeSelector.getItems();
			if (items.length == 0) {
				throw new Error("アイテムが選択されていません。");
			}

			if (isNaN(scale)) {
				throw new Error("引数が不正です。scale=" + scale);
			}

			let result = tool.itemMani.scale(this._ifdto, scale, scale);
			if (!result) {
				//エラーはNotice通知でくるのでここは抜けるだけ
				return;
			}

			this._ifdto.cleareCollbackError();
			callback({ code: 0 });

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * アイテム移動
	 */
	public moveItem(x: number, y: number, callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] moveItem.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "アイテム移動に失敗しました。", ex: e });
		});

		try {

			let items = this._ifdto.activeSelector.getItems();
			if (items.length == 0) {
				throw new Error("アイテムが選択されていません。");
			}

			if (isNaN(x) || isNaN(y)) {
				throw new Error("引数が不正です。x=" + x + ", y=" + y);
			}

			let result = tool.itemMani.move(this._ifdto, x, y);
			if (!result) {
				//エラーはNotice通知でくるのでここは抜けるだけ
				return;
			}

			this._ifdto.cleareCollbackError();
			callback({ code: 0 });

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * 画像リスト取得
	 */
	public getPhotoList(callback: (res: ifbase.IResult, list: any[]) => void): void {
		//console.log("[sonbpIf] getPhotoList.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "画像リスト取得に失敗しました。", ex: e }, []);
		});

		try {

			let list = tool.itemMani.getAllItems(this._ifdto, [ifbase.constants.ITYPE_PHOTO_BOX]);

			this._ifdto.cleareCollbackError();
			callback({ code: 0 }, list);

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * 写真枠に画像を配置（カレント枠）
	 */
	public setPhoto(file_key: string, file_id: string, img_size: { w: number, h: number }, keep_flg: boolean, callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] setPhoto.");
		let that = this;

		this._ifdto.setCallbackError(function (e) {
			if (!that._ifdto.callbackOnApiError(e)) return;
			callback({ code: 9, msg: "画像を配置（カレント枠）に失敗しました。", ex: e });
		});

		try {

			ifbase.util.chkNowMode(this._ifdto, [ifbase.constants.MODE_PHOTO_REGIST, ifbase.constants.MODE_PHOTO_MANI]);

			let items = this._ifdto.activeSelector.getItems();
			if (items.length == 0) {
				throw new Error("アイテムが選択されていません。");
			}

			tool.photoMani.setPhotoImg(this._ifdto, items[0].id, file_key, file_id, img_size, keep_flg, function (resKey) {

				// 画像読込
				that._ifdto.bpView._cm.getImgAsync(resKey).then((data) => {
					that._ifdto.bpView._dm.reDraw();
				});

				that._ifdto.cleareCollbackError();
				callback({ code: 0 });
			});
		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * 写真枠に画像を配置（ドラッグ＆ドロップ）
	 */
	public setPhotoDragger(e: MouseEvent, img: HTMLImageElement, file_key: string, file_id: string, img_size: { w: number, h: number }, callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] setPhotoDragger.");

		let that = this;
		let preSelectItem = this.getSelectItem();

		let modeRestore = function (e) {

			tool.poscaMode.changeMode(that._ifdto, that._ifdto.procMode);
			try {

				if (e.data != null) {
					tool.itemMani.selectItem(that._ifdto, e.data.item_type, e.data.idx);
				} else if (preSelectItem != null) {
					tool.itemMani.selectItem(that._ifdto, preSelectItem.item_type, preSelectItem.idx);
				}
			} catch (e) {
				console.warn(e);
			}
		}

		this._ifdto.setCallbackError(function (e) {
			modeRestore(e);
			if (!that._ifdto.callbackOnApiError(e)) return;
			callback({ code: 9, msg: "写真枠に画像を配置（ドラッグ＆ドロップ）に失敗しました。", ex: e });
		});

		let successFunc = function (e) {
			console.debug(e);

			modeRestore(e);
			that._ifdto.cleareCollbackError();
			callback({ code: 0 });
		};

		try {

			ifbase.util.chkNowMode(this._ifdto, [ifbase.constants.MODE_PHOTO_REGIST]);

			this._ifdto.bpImageDragger.onComplete(successFunc);
			this._ifdto.bpImageDragger.onCancel(successFunc);
			this._ifdto.bpView.setListener([this._ifdto.bpImageDragger, this._ifdto.bpFrontDrawer]);

			// 選択アイテムを再現
			this._ifdto.bpImageDragger.select(preSelectItem?.id);

			// ドラッグ開始
			this._ifdto.bpImageDragger.dragStart(img.src, file_key, file_id, img_size);

			e.preventDefault();

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * 画像枠から配置画像削除（ID指定）
	 */
	public removePhotoById(file_ids: string[], callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] removePhotoById.");
		let that = this;

		this._ifdto.setCallbackError(function (e) {
			if (!that._ifdto.callbackOnApiError(e)) return;
			callback({ code: 9, msg: "画像枠から配置画像削除（ID指定）に失敗しました。", ex: e });
		});

		try {

			ifbase.util.chkNowMode(this._ifdto, [ifbase.constants.MODE_PHOTO_MANI, ifbase.constants.MODE_PHOTO_REGIST]);

			let layer = ifbase.util.getLayer(this._ifdto, ifbase.constants.LTYPE_PHOTO).layer;
			let items = ifbase.util.getItems(layer.items, function (item): boolean {

				if (!ifbase.util.chkIsPhotobox(item)) return false;
				let gp = item as sonbp.object.groupItem;
				let fid = gp.childs[0].info.vendor_property.ffpsc?.file_id;

				return file_ids.indexOf(fid) >= 0;
			});

			console.debug("count", items.length);

			if (items.length == 0) {

				this._ifdto.cleareCollbackError();
				callback({ code: 0 });
				return;
			}

			let fn = function (idx) {

				tool.photoMani.removePhotoImg(that._ifdto, items[idx].id, function (resKey) {

					if (idx == items.length - 1) {

						// 画像読込
						that._ifdto.bpView._cm.getImgAsync(resKey).then((data) => {
							that._ifdto.bpView._dm.reDraw();
						});

						that._ifdto.cleareCollbackError();
						callback({ code: 0 });
					} else {

						fn(++idx);
					}
				});
			};

			fn(0);

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * 画像枠から配置画像削除（カレント枠）
	 */
	public removePhoto(callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] removePhoto.");
		let own = this;

		this._ifdto.setCallbackError(function (e) {
			if (!own._ifdto.callbackOnApiError(e)) return;
			callback({ code: 9, msg: "画像枠から配置画像削除（カレント枠）に失敗しました。", ex: e });
		});

		try {

			ifbase.util.chkNowMode(this._ifdto, [ifbase.constants.MODE_PHOTO_MANI, ifbase.constants.MODE_PHOTO_REGIST]);

			let items = this._ifdto.activeSelector.getItems();
			if (items.length == 0) {
				throw new Error("アイテムが選択されていません。");
			}

			let that = this;
			tool.photoMani.removePhotoImg(this._ifdto, items[0].id, function (resKey) {

				// 画像読込
				that._ifdto.bpView._cm.getImgAsync(resKey).then((data) => {
					that._ifdto.bpView._dm.reDraw();
				});

				that._ifdto.cleareCollbackError();
				callback({ code: 0 });
			});
		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * ２つの画像を入れ替え（タッチ式）
	 */
	public mutualTradePhoto(idxA: string, idxB: string, callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] mutualTradePhoto.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "２つの画像を入れ替え（タッチ式）に失敗しました。", ex: e });
		});

		try {

			let srcId: string;
			let dstId: string;

			let list = tool.itemMani.getAllItems(this._ifdto, [ifbase.constants.ITYPE_PHOTO_BOX]);
			for (let i = 0; i < list.length; i++) {
				let itemInfo = list[i];
				if (itemInfo.idx == idxA) srcId = itemInfo.id;
				else if (itemInfo.idx == idxB) dstId = itemInfo.id;
			}
			if (!srcId || !dstId) {
				throw new Error("idxA or idxB is invalid.");
			}

			ifbase.util.chkNowMode(this._ifdto, [ifbase.constants.MODE_PHOTO_REGIST]);

			let that = this;
			tool.photoMani.exchangePhotoImg(this._ifdto, srcId, dstId,
				function () {
					if (that._ifdto.bpSelectorWithExchangeSP._onExchangeCallback) {
						let refInfos = sonbp.tool.item.getRefInfos(that._ifdto.bpView, [srcId, dstId]);
						let a = {
							waku: refInfos[0].item.info.vendor_property.ffpsc,
							img: (<sonbp.object.groupItem>refInfos[0].item).childs[0].info.vendor_property.ffpsc
						};
						let b = {
							waku: refInfos[1].item.info.vendor_property.ffpsc,
							img: (<sonbp.object.groupItem>refInfos[1].item).childs[0].info.vendor_property.ffpsc
						};
						that._ifdto.bpSelectorWithExchangeSP._onExchangeCallback(a, b);
					}

					//選択解除
					that._ifdto.activeSelector.clear();

					that._ifdto.cleareCollbackError();
					callback({ code: 0 });
				},
				function (e) {

					this._ifdto.callbackError(e);
				});
		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * 選択アイテムの枠ぴったり区分セット
	 */
	public setPhotoWakuPita(doPita: boolean, callback: (res: ifbase.IResult) => void): void {
		console.log("[sonbpIf] setPhotoWakuPita.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "画像の枠ぴったり区分変更に失敗しました。", ex: e });
		});

		try {
			const items = this._ifdto.activeSelector.getItems();
			if (items.length == 0) {
				throw new Error("アイテムが選択されていません。");
			}

			tool.photoMani.setPhotoWakuPita(this._ifdto, items[0].id, doPita, () => {

				this._ifdto.bpView._dm.reDraw();

				this._ifdto.cleareCollbackError();
				callback({ code: 0 });
			});

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * テキストリスト取得
	 */
	public getTextList(callback: (res: ifbase.IResult, list: any[]) => void): void {
		//console.log("[sonbpIf] getTextList.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "テキストリスト取得に失敗しました。", ex: e }, []);
		});

		try {

			let list = tool.itemMani.getAllItems(this._ifdto, [ifbase.constants.ITYPE_GREETING_TXT, ifbase.constants.ITYPE_SENDER_TXT]);

			this._ifdto.cleareCollbackError();
			callback({ code: 0 }, list);

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * テキスト配置
	 */
	public setText(item_type: string, idx: string, json: string, def_posi: { x: number, y: number, w: number, h: number, gen: number }, muki: string, callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] setText.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "テキスト配置に失敗しました。", ex: e });
		});

		try {

			if (!item_type || item_type == "") {
				throw new Error("item_type is required.");
			}
			if (item_type != ifbase.constants.ITYPE_SENDER_TXT && (!idx || idx == "")) {
				throw new Error("idx is required.");
			}

			let expMode = (item_type == ifbase.constants.ITYPE_SENDER_TXT) ? ifbase.constants.MODE_SENDER_MANI : ifbase.constants.MODE_GREETING_MANI;
			ifbase.util.chkNowMode(this._ifdto, [expMode]);

			let that = this;
			tool.textMani.setText(this._ifdto, item_type, idx, json, def_posi, muki, function () {

				try {
					tool.itemMani.selectItem(that._ifdto, item_type, idx);
				} catch (e) {
					console.warn(e);
				}

				that._ifdto.cleareCollbackError();
				callback({ code: 0 });
			});

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * テキスト削除（カレント）
	 */
	public removeText(callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] removeText.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "テキスト削除（カレント枠）に失敗しました。", ex: e });
		});

		try {

			ifbase.util.chkNowMode(this._ifdto, [ifbase.constants.MODE_SENDER_MANI, ifbase.constants.MODE_GREETING_MANI]);

			let items = this._ifdto.activeSelector.getItems();
			if (items.length == 0) {
				throw new Error("アイテムが選択されていません。");
			}

			let result = sonbp.tool.item.remove(this._ifdto.bpView, items.map(d => d.id));

			if (result) {

				this._ifdto.cleareCollbackError();
				callback({ code: 0 });
			} else {

				throw new Error("sonbp.tool.item.remove result is false.");
			}
		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * スタンプリスト取得
	 */
	public getStampList(callback: (res: ifbase.IResult, list: any[]) => void): void {
		//console.log("[sonbpIf] getStampList.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "スタンプリスト取得に失敗しました。", ex: e }, []);
		});

		try {

			let list = tool.itemMani.getAllItems(this._ifdto, [ifbase.constants.ITYPE_STAMP_IMG, ifbase.constants.ITYPE_MYSTAMP_IMG, ifbase.constants.ITYPE_FONTGENIC_IMG]);

			this._ifdto.cleareCollbackError();
			callback({ code: 0 }, list);

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * スタンプ張り付け（スタンプ・マイスタンプ画像用）
	 */
	public setStamp(item_type: string, idx: string, file_key: string, file_id: string, img_size: { w: number, h: number }, callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] setStamp.");
		let that = this;

		this._ifdto.setCallbackError(function (e) {
			if (!that._ifdto.callbackOnApiError(e)) return;
			callback({ code: 9, msg: "スタンプ張り付けに失敗しました。", ex: e });
		});

		try {

			let expMode = (item_type == ifbase.constants.ITYPE_MYSTAMP_IMG) ? ifbase.constants.MODE_MYSTAMP_MANI : ifbase.constants.MODE_STAMP_MANI;
			ifbase.util.chkNowMode(this._ifdto, [expMode]);

			if (item_type != ifbase.constants.ITYPE_STAMP_IMG && item_type != ifbase.constants.ITYPE_MYSTAMP_IMG) {
				throw new Error("そのアイテム区分は指定できません。");
			}

			let layer = ifbase.util.getLayer(this._ifdto, ifbase.constants.LTYPE_STAMP).layer;
			let items = ifbase.util.getItems(layer.items, function (item): boolean {

				if (item.info.vendor_property.ffpsc?.item_type != item_type) return false;

				let vp = item.info.vendor_property.ffpsc;
				return (vp && vp.item_type == item_type && vp.idx == idx);
			});
			if (items.length > 0) {
				throw new Error("そのアイテム区分、番号のスタンプは既に存在します。");
			}

			tool.stampMani.setStampImg(this._ifdto, item_type, idx, file_key, file_id, img_size, function (resKey) {

				try {
					tool.itemMani.selectItem(that._ifdto, item_type, idx);
				} catch (e) {
					console.warn(e);
				}

				// 画像読込
				that._ifdto.bpView._cm.getImgAsync(resKey).then((data) => {
					that._ifdto.bpView._dm.reDraw();
				});

				that._ifdto.cleareCollbackError();
				callback({ code: 0 });
			});
		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * スタンプ張り付け（手書きスタンプ画像用）
	 */
	public setStampByFontGenic(idx: string, file_key: string, file_id: string, img_size: { w: number, h: number }, callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] setStampByFontGenic.");
		let that = this;

		this._ifdto.setCallbackError(function (e) {
			if (!that._ifdto.callbackOnApiError(e)) return;
			callback({ code: 9, msg: "手書きスタンプ張り付けに失敗しました。", ex: e });
		});

		try {

			let expMode = ifbase.constants.MODE_FONTGENIC_MANI;
			ifbase.util.chkNowMode(this._ifdto, [expMode]);

			let layer = ifbase.util.getLayer(this._ifdto, ifbase.constants.LTYPE_STAMP).layer;
			let items = ifbase.util.getItems(layer.items, function (item): boolean {
				let vp = item.info.vendor_property.ffpsc;
				return (vp && vp.item_type == ifbase.constants.ITYPE_FONTGENIC_IMG && vp.idx == idx);
			});

			if (items.length == 0) {

				//初期配置
				tool.stampMani.setStampImg(this._ifdto, ifbase.constants.ITYPE_FONTGENIC_IMG, idx, file_key, file_id, img_size, function (resKey) {

					try {
						tool.itemMani.selectItem(that._ifdto, ifbase.constants.ITYPE_FONTGENIC_IMG, idx);
					} catch (e) {
						console.warn(e);
					}

					// 画像読込
					that._ifdto.bpView._cm.getImgAsync(resKey).then((data) => {
						that._ifdto.bpView._dm.reDraw();
					});

					that._ifdto.cleareCollbackError();
					callback({ code: 0 });
				});
			} else {

				//色変え（画像変更）
				tool.stampMani.updateStampImg(this._ifdto, items[0].id, file_key, file_id, function (resKey) {

					try {
						tool.itemMani.selectItem(that._ifdto, ifbase.constants.ITYPE_FONTGENIC_IMG, idx);
					} catch (e) {
						console.warn(e);
					}

					// 画像読込
					that._ifdto.bpView._cm.getImgAsync(resKey).then((data) => {
						that._ifdto.bpView._dm.reDraw();
					});

					that._ifdto.cleareCollbackError();
					callback({ code: 0 });
				});
			}
		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}


	/**
	 * スタンプ削除（ID指定）
	 */
	public removeStampById(item_type: string, file_ids: string[], callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] removeStampById.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "スタンプ削除（ID指定）に失敗しました。", ex: e });
		});

		try {

			ifbase.util.chkNowMode(this._ifdto, [ifbase.constants.MODE_STAMP_MANI, ifbase.constants.MODE_MYSTAMP_MANI, ifbase.constants.MODE_FONTGENIC_MANI]);

			let layer = ifbase.util.getLayer(this._ifdto, ifbase.constants.LTYPE_STAMP).layer;
			let items = ifbase.util.getItems(layer.items, function (item): boolean {

				if (item.info.vendor_property.ffpsc?.item_type != item_type) return false;

				let fid = item.info.vendor_property.ffpsc?.file_id;
				return file_ids.indexOf(fid) >= 0;
			});

			console.debug("count", items.length);

			if (items.length == 0) {

				this._ifdto.cleareCollbackError();
				callback({ code: 0 });
				return;
			}

			let result = sonbp.tool.item.remove(this._ifdto.bpView, items.map(d => d.id));

			if (result) {

				this._ifdto.cleareCollbackError();
				callback({ code: 0 });
			} else {

				throw new Error("sonbp.tool.item.remove result is false.");
			}

		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * スタンプ削除（カレント）
	 */
	public removeStamp(callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] removeStamp.");

		this._ifdto.setCallbackError(function (e) {
			callback({ code: 9, msg: "スタンプ削除（カレント枠）に失敗しました。", ex: e });
		});

		try {

			ifbase.util.chkNowMode(this._ifdto, [ifbase.constants.MODE_STAMP_MANI, ifbase.constants.MODE_MYSTAMP_MANI, ifbase.constants.MODE_FONTGENIC_MANI]);

			let items = this._ifdto.activeSelector.getItems();
			if (items.length == 0) {
				throw new Error("アイテムが選択されていません。");
			}

			let result = sonbp.tool.item.remove(this._ifdto.bpView, items.map(d => d.id));

			if (result) {

				this._ifdto.cleareCollbackError();
				callback({ code: 0 });
			} else {

				throw new Error("sonbp.tool.item.remove result is false.");
			}
		} catch (e) {

			this._ifdto.callbackError(e);
		}
	}

	/**
	 * 操作履歴準備
	 * ・操作履歴をクリアする
	 * ・履歴数制限回避のためレストアポイントを設定する
	 */
	public historyStart(): boolean {
		//console.log("[sonbpIf] historyStart.");

		this._ifdto.bpView._hm.clear();
		return this._ifdto.bpView._hm.putRestorePoint();
	}

	/**
	 * 操作確定
	 * ・履歴をクリアする
	 * ・履歴数制限に戻すためレストアポイントをクリアする
	 */
	public historyCommit(): boolean {
		//console.log("[sonbpIf] historyCommit.");

		this._ifdto.bpView._hm.clear();
		return this._ifdto.bpView._hm.clearRestorePoint();
	}

	/**
	 * 操作取消
	 * ・操作履歴の先頭までUndoする
	 * ・履歴数制限に戻すためレストアポイントをクリアする
	 */
	public historyAllUndo(callback: (res: ifbase.IResult) => void): void {
		//console.log("[sonbpIf] historyAllUndo.");
		let own = this;

		this._ifdto.setCallbackError(function (e) {
			if (!own._ifdto.callbackOnApiError(e)) return;
			callback({ code: 9, msg: "Undoに失敗しました。", ex: e });
		});

		try {

			//操作履歴なしならレストア解除のみ
			if (this._ifdto.bpView._hm.undoCount <= 0) {
				this._ifdto.bpView._hm.clearRestorePoint();
				callback({ code: 0 });
				return;
			}

			//restore()だと完了検知できないのでallUndo()を利用する
			//allUndo()はresolve呼ばないのでnoticeで完了検知させる
			let that = this;
			this._ifdto.bpView._historyFuncs.push(function (event: sonbp.type.event): void {
				console.debug("_historyFuncs call.");
				that._ifdto.bpView._historyFuncs = [];
				that._ifdto.bpView._hm.clear();
				that._ifdto.bpView._hm.clearRestorePoint();
				callback({ code: 0 });
			});

			this._ifdto.bpView._hm.allUndo().catch((e) => {

				this._ifdto.callbackError(e);
			});
		} catch (e) {

			this._ifdto.callbackError(e);
		}
	
	}

	/* ============================================================
	 * 内部処理
	 * ============================================================ */

	/**
	 * アイテム選択変更通知
	 */
	private onChange(): (e: sonbp.type.event) => void {
		var own = this;
		return function (e: sonbp.type.event): void {
			//console.debug("[sonbpIf-debug] onChange]", e);

			try {

				if (own._ifdto._onChange) {

					let result = own._ifdto.activeSelector.getPoscaItem();

					own._ifdto._onChange(result);
				}
			} catch (e) {

				console.error("[sonbpIf-onChange] error.", e);
			}
		}
	}

	/**
	 * ２つの画像枠入替え通知
	 */
	private onExchange(): (a: { waku: any, img: any }, b: { waku: any, img: any }) => void {
		var own = this;
		return function (a: { waku: any, img: any }, b: { waku: any, img: any }): void {
			try {

				if (own._ifdto._onExchange) {
					own._ifdto._onExchange(a, b);
				}
			} catch (e) {

				console.error("[sonbpIf-onExchange] error.", e);
			}
		}
	}

	/** 基本リスナーに戻す
	*
	*/
	private setBaseListener(): any {

		var own = this;
		return function (e: sonbp.type.event): void {

			try {

				tool.poscaMode.changeMode(own._ifdto, own._ifdto.procMode);
			} catch (e) {

				own._ifdto.callbackError(e);
			}
		};
	}

	/**
	 * アイテム操作・変更通知
	 */
	private onEditStateFunc() {
		var own = this;
		return function (e) {
			//console.debug("[sonbpIf-debug] onEditStateFunc", e);

			////setShortcut();
			///own.onChange();
		}
	}

}
